module.exports = __webpack_public_path__ + "static/media/Photo6.ee9f7183.jpg";